import axios from 'axios';
import { jsonToFormData } from '../../presetation/utils/converJsonToFormData';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.put['Access-Control-Allow-Origin'] = '*';

const path = "/criancas";
const subPath = "/documentacao"

class DocumentacaoService {
  cadastrarDocumentacao(id, documentacao) {
    return axios.post(API + path + `/${id}` + subPath, jsonToFormData(documentacao, {}));
  }

  atualizarDocumentacao(id, documentacao) {
    return axios.put(API + path + `/${id}` + subPath, jsonToFormData(documentacao, {}));
  }

  getDocumentacaoValidar(id, numeroDocumento) {
    return axios.get(API + path + `/${id}` + subPath + `/validar?numeroDocumento=${numeroDocumento}`)
  }

  getDocumentacao(id) {
    return axios.get(API + path + `/${id}` + subPath)
  }
}

const instanceDocumentacao = new DocumentacaoService();
export default instanceDocumentacao;